




































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import SliderInput from '~/components/inputs/SliderInput.vue';
import ExternalOutline from '~/components/icons/ExternalOutline.vue';
import InfoOutline from '~/components/icons/InfoOutline.vue';
import Dropdown from '~/components/partials/Dropdown.vue';

type Btn = {id: number, name: string, style: string, isClicked: boolean, clickedStyle: string, isDisabled: boolean};

@Component({
  components: {
    ChevronRightSolid,
    SliderInput,
    ExternalOutline,
    InfoOutline,
    Dropdown,
  },
})
export default class RoutesDifficultyDropdown extends Vue {
  @Prop(Array) prefilledDifficulties: number[];
  @Prop(Number) minElevation: number;
  @Prop(Number) maxElevation: number;

  @Prop(Number) minDistance: number;
  @Prop(Number) maxDistance: number;

  elevationRange: number[] = [0, 5000];
  distanceRange: number[] = [0, 150];

  difficultyBtns: Btn[] = [
    {
      id: 0,
      name: this.$t('routesDifficultyDropdown.insecureLabel'),
      style: 'Btn-wired-gray-unsecured',
      isClicked: false,
      clickedStyle: 'Btn-filled-gray-unsecured',
      isDisabled: false,
    },
    {
      id: 1,
      name: this.$t('routesDifficultyDropdown.easyLabel'),
      style: 'Btn-wired-green',
      isClicked: false,
      clickedStyle: 'Btn-filled-green',
      isDisabled: false,
    },
    {
      id: 2,
      name: this.$t('routesDifficultyDropdown.normalLabel'),
      style: 'Btn-wired-info',
      isClicked: false,
      clickedStyle: 'Btn-filled-info',
      isDisabled: false,
    },
    {
      id: 3,
      name: this.$t('routesDifficultyDropdown.hardLabel'),
      style: 'Btn-wired-primary',
      isClicked: false,
      clickedStyle: 'Btn-filled',
      isDisabled: false,
    },
    {
      id: 4,
      name: this.$t('routesDifficultyDropdown.veryHardLabel'),
      style: 'Btn-wired-black',
      isClicked: false,
      clickedStyle: 'Btn-filled-black',
      isDisabled: false,
    },
  ];

  $refs: {
    dropdown: HTMLButtonElement;
    chevron: Vue;
  };

  /*
    If this.prefilledDifficulties is defined, we select them in template +
    update associated datas
  */
  @Watch('prefilledDifficulties')
  handlePrefilledDifficulties () {
    this.prefilledDifficulties?.map((d: number) => {
      this.difficultyBtns.map((b: Btn) => {
        if (b.id === d) b.isClicked = true;
      });
    });
  }

  /*
    This watcher will allow the selection of difficulties if elevations values
    are the default ones. If not, we define this.elevationRange
  */
  @Watch('minElevation')
  @Watch('maxElevation')
  handlePrefilledElevation () {
    if (this.minElevation !== 0) this.elevationRange[0] = this.minElevation; this.allowDifficulties();
    if (this.maxElevation !== 5000) this.elevationRange[1] = this.maxElevation; this.allowDifficulties();

    this.elevationRange = [this.minElevation, this.maxElevation];
  }

  /*
    This watcher will allow the selection of difficulties if distance values
    are the default ones. If not, we define this.distanceRange
  */
  @Watch('minDistance')
  @Watch('maxDistance')
  handlePrefilledDistance () {
    if (this.minDistance !== 0) this.distanceRange[0] = this.minDistance; this.allowDifficulties();
    if (this.maxDistance !== 150) this.distanceRange[1] = this.maxDistance; this.allowDifficulties();

    this.distanceRange = [this.minDistance, this.maxDistance];
  }

  /*
    This watcher will check if elevationRange or distanceRange are defined on
    default values. If so, we don't want these values to be applied parent-side
    as filters, as it's not useful.
  */
  @Watch('elevationRange')
  @Watch('distanceRange')
  resetIfAtZero () {
    if (this.elevationRange[0] === 0 && this.elevationRange[1] === 5000) {
      this.$emit('elevation-chosen', []);
    }
    if (this.distanceRange[0] === 0 && this.distanceRange[1] === 150) {
      this.$emit('distance-chosen', []);
    }
  }

  /* Returns the chosen difficulties in template */
  get difficultyChosen () {
    return this.difficultyBtns.some((btn: Btn) => btn.isClicked);
  }

  /* Returns a width for the dropdown based on device's innerWidth */
  get dropdownWidth () {
    if (process.client) {
      return window.innerWidth < 768 ? 'w-full' : 'min-w-44';
    }
    return '';
  }

  /*
    This computed gives a hint to check if user has applied any filter in
    template. It will update dropdown style if yes.
  */
  get filterHasBeenApplied () {
    const difficultyChosen = this.difficultyBtns.some((d: Btn) => d.isClicked === true);
    const elevationChosen = this.elevationRange[0] !== 0 || this.elevationRange[1] !== 5000;
    const distanceChosen = this.distanceRange[0] !== 0 || this.distanceRange[1] !== 150;

    return difficultyChosen || elevationChosen || distanceChosen;
  }

  mounted () {
    // Listens to a global reset event from explorer parents
    this.$root.$on('reset-routes-ranges', () => {
      this.elevationRange = [0, 5000];
      this.distanceRange = [0, 150];

      /* eslint no-return-assign: 0 */
      this.difficultyBtns.map((btn: Btn) => btn.isClicked = false);
    });
  }

  /* Handle clicks of user inside of the dropdown btn to close/open the dropdown */
  handleClick (val: boolean) {
    if (!val) this.bluredBtn();
    else this.focusedBtn();
  }

  /* This method disables all difficulties when chosing any other filter than it */
  allowDifficulties () {
    /* eslint array-callback-return: 0 */
    this.difficultyBtns.map((btn: Btn) => {
      btn.isClicked = false;
      btn.isDisabled = true;
    });
    this.$emit('difficulties-chosen', []);

    // Applies fake-disable style to the sliders
    if (process.client) {
      const sliders = document.querySelectorAll('.vue-slider-process');
      for (let i = 0; i < sliders.length; i++) {
        sliders[i].classList.remove('opacity-50');
      }
    }
  }

  /*
    This method handles the behavior of a clicked difficulty, with its styles,
    its status, and also resets chosen ranges from other filters.
  */
  updateDifficulty (btn: Btn) {
    btn.isClicked = !btn.isClicked;

    const difficulties: number[] = [];
    /* eslint-disable-next-line */
    this.difficultyBtns.map((btn: Btn) => {
      btn.isDisabled = false;
      if (btn.isClicked) {
        difficulties.push(btn.id);
      }
    });
    this.$emit('difficulties-chosen', difficulties);
    this.$emit('elevation-chosen', []);
    this.$emit('distance-chosen', []);
    this.$emit('has-updated');
    this.elevationRange = [0, 5000];
    this.distanceRange = [0, 150];

    // Applies fake-disable style to the sliders
    if (process.client) {
      const sliders = document.querySelectorAll('.vue-slider-process');
      for (let i = 0; i < sliders.length; i++) {
        sliders[i].classList.add('opacity-50');
      }
    }
  }

  /* Applies focused styles on dropdown */
  focusedBtn () {
    this.$refs.dropdown.classList.remove('border-gray-200');
    this.$refs.dropdown.classList.add('border-gray-default');
    this.$refs.chevron.$el.classList.add('-rotate-180', '-rotate-90');
  }

  /*
    Remove the dropdown is user clicks outside of it.
    Also ensures that if user has selected default values in sliders, it will
    remove the actives stylings on dropdown
  */
  bluredBtn () {
    if (
      !this.difficultyChosen &&
      this.elevationRange[0] === 0 && this.elevationRange[1] === 5000 &&
      this.distanceRange[0] === 0 && this.distanceRange[1] === 150
    ) {
      this.$refs.dropdown.classList.add('border-gray-200');
    } else {
      this.$refs.chevron.$el.classList.remove('-rotate-180', '-rotate-90');
      return this.$refs.dropdown.classList.add('border-gray-default');
    }
    this.$refs.dropdown.classList.remove('border-gray-default');
    this.$refs.chevron.$el.classList.remove('-rotate-180', '-rotate-90');
  }
}
